import { z } from 'zod';

import { apiRequest } from '@/api/client';

/**
 * Schemas mirroring `app/schemas/referrals.py`.
 *
 * The check endpoint answers 200 whatever it thinks of the code - a mistyped
 * referral is a normal thing for somebody to do halfway through typing, not a
 * failed request. `valid` carries the verdict and `message` carries the
 * sentence to show; nothing here throws for a bad code.
 */

export const referralCheckSchema = z.object({
  code: z.string(),
  valid: z.boolean(),
  partner_name: z.string().nullable(),
  /**
   * A ready-to-render sentence - "10% off your first subscription payment, up
   * to ₹2000". Null on a valid code means tracking only: the partner is
   * credited for the introduction, the merchant is not discounted.
   */
  benefit: z.string().nullable(),
  reason: z.string().nullable(),
  message: z.string().nullable(),
});

export type ReferralCheck = z.infer<typeof referralCheckSchema>;

export function checkReferralCode(code: string): Promise<ReferralCheck> {
  return apiRequest('/referrals/check', referralCheckSchema, {
    method: 'POST',
    body: { code },
    // Anybody can ask, signed in or not, so a 401 here is not worth a refresh.
    skipAuthRefresh: true,
  });
}
